/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates.
 * The Universal Permissive License (UPL), Version 1.0
 * as shown at https://oss.oracle.com/licenses/upl/
 * @ignore
 */

import { styles } from '#PRIVATE_BaseLegend/themes/LegendStyles.css';

type ImageMarkerProps = {
  source: string;
};

export function ImageMarker(props: ImageMarkerProps) {
  const { imageMarkerStyle } = styles;
  return <img class={imageMarkerStyle} src={props.source} role="none" />;
}
